<!-- <app-preloader></app-preloader> -->
<!-- <p-toast></p-toast> -->
<router-outlet></router-outlet>
<app-footer *ngIf="!(location == '/login' || location == '/register' || location == '/coming-soon')"></app-footer>